import React, { useEffect, useRef, useState } from "react";
import classes from './OptionDropdowns.module.css';
import DownArrowDropdown from "../DownArrowDropdown/DownArrowDropdown";
import { useNavigate } from "react-router-dom";

const OptionDropdown = (props) => {
    const navigate = useNavigate();

    let [dsp, setDsp] = useState("none");
    let [plc, setPlc] = useState('');
    const [logoutTimerId,setLogoutTimerId] = useState(null);
    const divRef = useRef(null);

    let [options, setOptions] = useState([]);

    useEffect(() => {
        if (props.plc) {
            setPlc(props.plc);
        }
        if (props.options) {
            setOptions(props.options);
        }
    }, [])

    useEffect(() => {
        const handleClickOutside = (event) => {
          if (divRef.current && !divRef.current.contains(event.target)) {
            setDsp("none");
          }
        };
    
        document.addEventListener('click', handleClickOutside);
    
        return () => {
          document.removeEventListener('click', handleClickOutside);
        };
      }, []);



    const dspHandler = () => {
        setDsp("block");
    }

    const dspRemoveHandler = () => {
        setDsp("none");
    }

    const strokeColor = props.strokeColor || 'black';

    return (
        <>
            <div ref={divRef} className={classes['entry-component-search-box-container']}>
                <div onClick={dspHandler}>
                    <DownArrowDropdown strokeColor={strokeColor} />
                </div>
                <div className={classes['entry-dropdown-container']}
                    onMouseLeave={() => {
                        const id = setTimeout(() => {
                            dspRemoveHandler();
                        }, 500);
                        setLogoutTimerId(id)
                    }}
                    onMouseEnter={() => {
                        clearTimeout(logoutTimerId);
                        setTimeout(() => {
                            dspHandler();
                        }, 500)
                    }}
                    style={{ display: `${dsp}` }}>
                    <div style={{ margin: 0 }}>
                        {
                            options.map(op => {
                                return (
                                    <>
                                        <p onClick={() => { op.action();  dspRemoveHandler(); }} className={classes['entry-dropdown-options']} >{op.label || op}</p>
                                    </>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </>
    )
};

export default OptionDropdown;